module.exports = __webpack_public_path__ + "static/media/experience-strict-hygiene.cddb020f.jpg";